@if (show) {
  <div class="spinner-container">
    <div class="spinner-container-height"></div>
    <mat-spinner class="text-center mx-auto opacity1" />
  </div>
}
